import React, { useState } from 'react';
import cn from 'classnames';

import ExportRules from '@components/ExportRules';

import { TExportAssetsRulesDTO } from '@interfaces/assets/dto/assetsDTO';

import { EOrganizationType } from '@enums/common';

import { exportAssetsDefaultRules } from '@constants/common';
import { assetOwnerRulesHelperText, networkOperatorRulesHelperText } from './constants';

import styles from './ExportAssetsRulesForm.module.scss';

interface IExportAssetsFormParams {
	exportAssetsRules: {
		assetOwnerRule: TExportAssetsRulesDTO;
		networkOperatorRule: TExportAssetsRulesDTO;
	};
	isLoadingForm: boolean;
	updateSubmitHandler: () => void;
}

const ExportAssetsRulesForm = ({
	exportAssetsRules,
	isLoadingForm,
	updateSubmitHandler,
}: IExportAssetsFormParams) => {
	const [isActiveAssetOwnerRole, setIsActiveAssetOwnerRole] = useState(true);

	const [assetOwnerRules, setAssetOwnerRules] = useState<TExportAssetsRulesDTO>(
		exportAssetsRules?.assetOwnerRule || exportAssetsDefaultRules,
	);
	const [networkOperatorRules, setNetworkOperatorRules] = useState<TExportAssetsRulesDTO>(
		exportAssetsRules?.networkOperatorRule || exportAssetsDefaultRules,
	);

	const changeRoleRules = () => {
		if (isLoadingForm) return;

		setIsActiveAssetOwnerRole(prev => !prev);
	};

	return (
		<div data-testid='export-rules-container'>
			<div className={styles.chooseRole}>
				<div
					className={cn(styles.roleContainer, {
						[styles.activeRole]: isActiveAssetOwnerRole,
					})}
					onClick={changeRoleRules}
				>
					Asset Owner
				</div>
				<div
					className={cn(styles.roleContainer, {
						[styles.activeRole]: !isActiveAssetOwnerRole,
					})}
					onClick={changeRoleRules}
				>
					Others
				</div>
			</div>
			{isActiveAssetOwnerRole
				? <ExportRules
					helperText={assetOwnerRulesHelperText}
					isLoadingForm={isLoadingForm}
					rules={assetOwnerRules}
					setRules={setAssetOwnerRules}
					type={EOrganizationType.assetOwner}
					updateSubmitHandler={updateSubmitHandler}
				/>
				: <ExportRules
					helperText={networkOperatorRulesHelperText}
					isLoadingForm={isLoadingForm}
					rules={networkOperatorRules}
					setRules={setNetworkOperatorRules}
					type={EOrganizationType.networkOperator}
					updateSubmitHandler={updateSubmitHandler}
				/>
			}
		</div>
	);
};

export default ExportAssetsRulesForm;
